import { Facebook } from "lucide-react";
import { BRAND } from "./data";
import { Logo } from "./Logo";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";

export const Footer = () => {
  const { settings } = useContent();
  const tx = useTx();
  const phone = settings.phone || BRAND.phone;
  const address = settings.address || BRAND.address;
  const phoneHref = `tel:+1${phone.replace(/\D/g, "")}`;

  return (
    <footer className="bg-cantina-navydeep text-cantina-cream" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-10 pb-10 border-b border-white/10">
          <div className="space-y-5">
            <Logo />
            <p className="max-w-sm font-sans text-cantina-cream/60" style={txtStyle(tx("footer.tagline"))}>
              {tx("footer.tagline").text}
            </p>
          </div>
          <div className="flex items-center gap-4">
            <a href={BRAND.facebook} target="_blank" rel="noopener noreferrer" className="btn-outline flex items-center justify-center w-12 h-12 border border-white/20 rounded-full text-cantina-cream hover:bg-cantina-cream hover:text-cantina-navy" data-testid="footer-facebook" aria-label="Facebook">
              <Facebook size={18} />
            </a>
            <a href={BRAND.orderUrl} target="_blank" rel="noopener noreferrer" className="btn-primary bg-cantina-marigold text-cantina-navy font-sans tracking-wide px-7 py-3.5 rounded-full" style={txtStyle(tx("footer.orderLabel"))} data-testid="footer-order-button">
              {tx("footer.orderLabel").text}
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:justify-between gap-4 pt-8 text-cantina-cream/60">
          <p className="font-sans text-sm">{address}</p>
          <a href={phoneHref} className="font-sans text-sm hover:text-cantina-cream transition-colors">{phone}</a>
          <p className="font-sans" style={txtStyle(tx("footer.copyright"))}>© {new Date().getFullYear()} Blue Tequila · {tx("footer.copyright").text}</p>
        </div>
      </div>
    </footer>
  );
};
